import React from 'react';
import './sponsors.css'; // Ensure this CSS file exists

const sponsors = [
    { 
        name: 'Bhupesh Kumar Bajiya', 
        year: 2024, 
        photo: 'bhupesh.jpg', 
        linkedin: 'https://www.linkedin.com/in/bhupesh-kumar-884778201/'
    },
    { 
        name: 'Deep Bansal', 
        year: 2024, 
        photo: 'deep.jpg', 
        linkedin: 'https://www.linkedin.com/in/deep-bansal-351009212/'
    },
    { 
        name: 'Vanshika Chauhan', 
        year: 2024, 
        photo: 'vanshika.jpg', 
        linkedin: 'https://www.linkedin.com/in/vanshika-chauhan-02b252200/'
    },
    { 
        name: 'Ajit Kumar', 
        year: 2024, 
        photo: 'ajit.jpg', 
        linkedin: null
    },
];

const Sponsors = () => {
    return (
        <div className="sponsors-container">
            <div className="sponsor-grid">
                {sponsors.map((sponsor, index) => (
                    <div key={index} className="sponsor-card">
                        <img src={require(`./pics/${sponsor.photo}`)} alt={sponsor.name} className="sponsor-photo" />
                        <div className="sponsor-info">
                            <h3>{sponsor.name}</h3>
                            <p className="sponsor-year">Batch of {sponsor.year}</p>
                            <a href={sponsor.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-button">
                                <img src={require('./linkedin.png')} width={30}/>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
            {/* <h1 className="sponsors-heading">Our Prime Alumni</h1> */}
        </div>
    );
};

export default Sponsors;